import { eParentChangeBehavior, KbViewerSettings } from '@kb3d/models/interfaces/settings';

const settingDefaults: KbViewerSettings = {
    parentChangeBehavior: eParentChangeBehavior.PRESERVE_POSITION,
};
type KbViewerSettingsOptions = keyof KbViewerSettings;
const settingsKey = 'KBVIEWER_SETTINGS';

const savedSettings = localStorage.getItem(settingsKey);
const settings: KbViewerSettings = savedSettings
    ? { ...settingDefaults, ...JSON.parse(savedSettings) }
    : { ...settingDefaults };

export class SettingsManagerService {
    static get<T extends KbViewerSettingsOptions>(name: keyof KbViewerSettings): KbViewerSettings[T] {
        return settings[name];
    }

    static set<T extends KbViewerSettingsOptions>(name: keyof KbViewerSettings, value: KbViewerSettings[T]): void {
        settings[name] = value;
        localStorage.setItem(settingsKey, JSON.stringify(settings));
    }
}
